<template>
  <div class="avatar">
    <div class="img-wrapper">
      <div :style="getStyle"
           :class="avatarUrl?'':'border-class'"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'avatar',
  props: {
    avatarUrl: String,
    size: {
      type: [Number, String],
      default: 60,

    },
    radius: {
      default: '100%'
    }
  },
  computed: {
    getStyle () {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        backgroundImage: `url(${this.avatarUrl})`,
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        borderRadius: this.radius
      }
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.img-wrapper {
  img {
    border-radius: 100%;
  }
  .border-class {
    border: 1px solid #e9e9e9;
  }
}
</style>
